import primaryColor from '@mui/material/colors/green';
export default function Style(theme) {
    const style = {
        avatar: {
          backgroundColor: primaryColor[100],
          color: primaryColor[600],
        },
        root: {
          padding: 8
        },
        button: {
          margin: 8,
          width: "auto"
        },
        buttonLink: {
          width: "100%"
        },
        link: {
          margin: 8,
          display: "block",
          textDecoration: 'none'
        }
      }
    return style
}